var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnSmartlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.5,
    width: 14,
    height: 13,
    rx: 3,
    fill: "#262949"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6213 12L21.2678 12.3536L17.0607 16.5607C16.4749 17.1464 15.5251 17.1464 14.9393 16.5607C14.3536 15.9749 14.3536 15.0251 14.9393 14.4393L15.8787 13.5H10.5C9.67157 13.5 9 12.8284 9 12C9 11.1716 9.67157 10.5 10.5 10.5H15.8787L14.9393 9.56066C14.3536 8.97487 14.3536 8.02513 14.9393 7.43934C15.5251 6.85355 16.4749 6.85355 17.0607 7.43934M21.6213 12L17.0607 7.43934M21.6213 12L21.2678 11.6464L17.0607 7.43934M21.6213 12L16.7071 7.79289L17.0607 7.43934",
    fill: "#EA7E68",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSmartlink);
export default __webpack_public_path__ + "static/media/icn-smartlink.d35cb1a6726722831ed77d4b6247ce5b.svg";
export { ForwardRef as ReactComponent };